module.exports = __webpack_public_path__ + "static/media/theengine.542fac87.jpg";